import { CustomAttr } from "@turizi/shared";
import { useInputSuggestions } from "@/hooks/api-hooks";

/**
 * Hook to get dynamic options for an attribute based on context
 * @param attr - The custom attribute
 * @param context - Context containing type and id (e.g., { type: 'service', id: 123 })
 * @returns Object with data (suggestions array), isLoading state, and static options fallback
 */
export const useDynamicOptions = (attr: CustomAttr | null, context?: { type: string; id: string | number }) => {
    const baseKey = attr?.key?.split('#')?.[0] || attr?.key;
    const shouldFetch = !!(context?.type && context?.id && baseKey);
    const { data, isLoading } = useInputSuggestions(
        {
            type: context?.type,
            id: context?.id,
            key: baseKey
        },
        { enabled: shouldFetch }
    );

    const rawData = data?.data?.filter(Boolean) || attr?.options || [];
    const formattedData = rawData.map((s: any) => typeof s === 'string' ? { value: s } : s);

    return {
        data: formattedData,
        isLoading: shouldFetch ? isLoading : false,
    };
};
